import React from "react";
import { Typography } from "@material-ui/core";
import styles from "./BillingPartSummary.module.scss";
import { IBillingPart } from "nodeDetails/types";
import { useDomainNumberFormatter } from "common/useNumberFormatter";
import Row from "./Row";
import { calculateBillingPartTotal } from "nodeDetails/functions/billingResultFunctions";
import { useTranslation } from "react-i18next";

interface Props {
  part: IBillingPart;
}

const BillingPartSummary = ({ part }: Props) => {
  const { t } = useTranslation();
  const { formatCurrency } = useDomainNumberFormatter();

  const partTotal = calculateBillingPartTotal(part);

  return (
    <div>
      <Typography className={styles.title} variant="h3">
        {t("Subtotal")}
      </Typography>
      <Row
        label={t("Price rounding")}
        value={formatCurrency(partTotal.rounding)}
      />
      <Row
        label={t("Total")}
        value={formatCurrency(
          partTotal.total + partTotal.vat + partTotal.rounding
        )}
      />
      <Row label={t("Tax")} value={formatCurrency(partTotal.vat)} />
    </div>
  );
};

export default BillingPartSummary;
